{
  "common": {
    "itemActionsAriaLabel": "More options",
    "permissionDeniedTooltipText": "You don't have permission to perform this action."
  },
  "form": {
    "backButtonLabel": "Back",
    "cancelButtonLabel": "Cancel",
    "closeButtonLabel": "Close",
    "deleteButtonLabel": "Delete",
    "doneButtonLabel": "Done",
    "editButtonLabel": "Edit",
    "removeButtonLabel": "Remove",
    "resetButtonLabel": "Reset",
    "saveButtonLabel": "Save",
    "selectButtonLabel": "Select",
    "sendButtonLabel": "Send",
    "submitButtonLabel": "Submit",
    "multiSelect": {
      "optionsHint": "Select all that apply.",
      "optionsHintMax": "Select up to {{max}}."
    },
    "undoButtonLabel": "Undo",
    "radioOptions": {
      "yes": "Yes",
      "no": "No"
    },
    "upload": {
      "previewListAriaLabel": "Uploaded files",
      "uploadedFilePreviewAriaLabel": "Uploaded file preview: {{fileName}}",
      "uploadedFileAriaLabel": "Uploaded file: {{fileName}}",
      "uploadedFileWithSizeAriaLabel": "Uploaded file: {{fileName}}, size: {{fileSize}}",
      "clickActionLabel": "Click to upload",
      "dragDropActionLabel": "or drag and drop",
      "genericAltText": "Preview of the uploaded image.",
      "deleteFileLabel": "Delete file",
      "deleteFileWithNameLabel": "Delete file: {{fileName}}",
      "undoDeleteFileLabel": "Undo deletion of file",
      "undoDeleteFileWithNameLabel": "Undo deletion of file: {{fileName}}",
      "errors": {
        "invalidFileType": "Invalid file type.",
        "invalidImgDimensions": "Invalid dimensions. The image must be at most {{dimensions}}.",
        "invalidFileSize": "Invalid file size. File exceeds the max. limit: {{maxSizeMB}} MB",
        "maxCount": "You can upload at most {{maxCount}} files. Extra files were not added.",
        "optionalShapefileOrphaned": "Optional shapefile has to be accompanied by a .shp file, matched by its base name.",
        "invalidUnzippedFileSize": "Upload failed: unzipped file exceeds size limit. Please try again.",
        "invalidGeoJson": "This file contains invalid location data and cannot be uploaded.",
        "imageProcessingFailed": "This image could not be processed. Please try a different file.",
        "uploadFailed": "Upload failed. Please try again."
      }
    },
    "colorPicker": {
      "placeholder": "Select Color",
      "emptyColorAlt": "No color selected",
      "clear": "Clear color",
      "selected": "{{color}} selected",
      "colors": {
        "pink": "Pink",
        "rust": "Rust",
        "red": "Red",
        "orange": "Orange",
        "amber": "Amber",
        "yellow": "Yellow",
        "lime": "Lime",
        "lightGreen": "Light green",
        "green": "Green",
        "teal": "Teal",
        "cyan": "Cyan",
        "blue": "Blue",
        "royalBlue": "Royal blue",
        "indigo": "Indigo",
        "purple": "Purple",
        "violet": "Violet",
        "gray": "Gray",
        "brown": "Brown",
        "white": "White",
        "black": "Black"
      }
    },
    "iconPicker": {
      "clear": "Clear Search",
      "foundResults": "Found {{count}} icons",
      "suggestedIcons": "Suggested icons"
    },
    "removeChip": {
      "ariaLabel": "Remove {{label}}"
    },
    "errors": {
      "invalid": "{{field}} is invalid.",
      "invalidBillingAccount": "{{field}} must be a level 2 billing account ({{length}} characters).",
      "length": "{{field}} must be {{length}} characters.",
      "maxLength": "{{field}} must have a maximum of {{maxLength}} characters.",
      "min": "{{field}} must be at least {{min}}.",
      "minSelections": "{{field}} must have at least {{min}} selections.",
      "maxSelections": "{{field}} must have at most {{max}} selections.",
      "minLength": "{{field}} must be at least {{minLength}} characters.",
      "notUnique": "{{field}} must be unique.",
      "required": "{{field}} is required."
    }
  },
  "admin": {
    "projectTeamName": "Project Team",
    "sideNavMenu": {
      "project": {
        "title": "Project",
        "list": "Project List",
        "settings": {
          "label": "Project Settings",
          "subitems": {
            "info": "Project Info",
            "collaborators": "Collaborators",
            "map": "Maps & Layers",
            "comments": "Comment Categories",
            "survey": "Survey",
            "projectPage": "Project Page",
            "legacyProjectPage": "Legacy Project Page",
            "projectPageCmsBuilder": "Project Page",
            "phases": "Phases",
            "translations": "Translations"
          }
        }
      },
      "account": {
        "info": "Organization Settings",
        "userManagement": "User Management"
      },
      "overview": "Overview",
      "comments": "Comments",
      "surveyResponses": "Survey Responses",
      "phase": "Phase"
    },
    "feedback": {
      "header": {
        "form": "Submit Feedback",
        "confirmation": "Thank you for your feedback!"
      },
      "subheader": "We value your feedback! Your insights help us improve and provide exceptional service.",
      "instructions": "*Indicates required fields",
      "feedbackTypes": {
        "bug": "Report an issue",
        "question": "Ask a Question",
        "featureRequest": "Suggest a Feature"
      },
      "form": {
        "feedbackType": "I would like to...",
        "description": {
          "title": {
            "bug": "Describe your issue",
            "question": "Describe Your Question",
            "featureRequest": "Describe Your Feature Idea"
          },
          "footer": "Provide details to help us assist you effectively."
        },
        "attachment": {
          "title": "Upload Image",
          "hint": "SVG, PNG, JPG, JPEG, or GIF (max 800x400px)"
        }
      },
      "successBody": {
        "message": "We use feedback like yours to help fix issues and improve the PublicCoordinate user experience. Someone from our team will be in touch via email.",
        "confirmationMessage": "Feel free to reference confirmation number ",
        "endOfConfirmationMessage": ", if needed."
      },
      "footer": {
        "initialText": "Some account and system information may be sent to KHTS, Inc. We will use these details to address problems and improve our product, subject to our ",
        "privacyPolicy": "Privacy Policy",
        "and": "and",
        "termsOfUse": "Terms of Use",
        "opensInNewTab": "(opens in a new tab)",
        "endingText": ". We may contact you for more information or updates using your saved contact information."
      },
      "errorSnackbar": "There was an error submitting your feedback. Please try again later."
    },
    "organization": {
      "title": "Organization",
      "settings": {
        "title": "Organization Settings",
        "editButtonLabel": "Edit Organization Settings",
        "organizationNameLabel": "Organization Name",
        "organizationLogoLabel": "Organization Logo",
        "defaultOrganizationRolesLabel": "Default Organization Roles",
        "defaultProjectRolesLabel": "Default Project Roles",
        "licenseTierLabel": "Subscription Plan Name",
        "numberOfProjectsLabel": "Number of Projects",
        "allowedNumberOfProjectsLabel": "Allowed Number of Projects",
        "unlimited": "Unlimited",
        "form": {
          "header": "Edit Organization Settings",
          "fields": {
            "organizationName": {
              "label": "Organization Name"
            },
            "logo": {
              "label": "Organization Logo",
              "hint": "SVG, PNG, JPEG or GIF"
            },
            "defaultOrganizationRoles": {
              "label": "Default permission for adding users"
            },
            "defaultProjectRoles": {
              "label": "Default permission for adding users to projects"
            }
          }
        },
        "notifications": {
          "settingsSaved": "Settings have been saved."
        }
      },
      "users": {
        "title": "User Management",
        "table": {
          "headers": {
            "displayName": "Name",
            "emailAddress": "Email",
            "status": "Status",
            "roles": "Roles",
            "actions": "Actions"
          },
          "values": {
            "active": "Active",
            "invited": "Invited",
            "removed": "Removed",
            "none": "None",
            "organizationOwner": "Organization Owner",
            "organizationViewer": "Organization Viewer",
            "organizationProjectCreator": "Organization Project Creator",
            "resendInvite": "Resend Invite",
            "addUser": "Add User",
            "removeUser": "Remove User",
            "editRole": "Edit Role",
            "removeUserConfirmation": "Are you sure you want to remove access for the following user?",
            "filters": "Filters"
          }
        },
        "notifications": {
          "removeUserSuccess": "User successfully removed",
          "removeUserFailed": "Remove user failed",
          "addUserInviteSent": "Invite sent",
          "addUserInviteResent": "Invite has been re-sent",
          "editRoleSuccess": "User role successfully updated"
        },
        "addUserForm": {
          "header": "Invite New User",
          "form": {
            "fields": {
              "emailAddress": {
                "label": "Email"
              },
              "addToProject": {
                "label": "Add to Project (Optional)"
              }
            },
            "buttonText": "Send Invite"
          },
          "permissions": {
            "label": "Organization Permissions",
            "tooltip": "If you want this user to have access only to specific projects, leave blank and send invite."
          }
        },
        "addOrganizationOwnerForm": {
          "header": "Invite Organization Owner",
          "form": {
            "fields": {
              "emailAddress": {
                "label": "Email"
              }
            },
            "buttonText": "Send Invite"
          }
        },
        "resendInviteConfirmation": {
          "header": "Resend Invite",
          "message": "Are you sure you want to resend invite for the following user?",
          "buttonText": "Resend Invite"
        },
        "editRole": {
          "header": "Edit Role",
          "buttonText": "Save"
        }
      }
    },
    "projects": {
      "title": "Projects",
      "table": {
        "headers": {
          "name": "Project Name",
          "status": "Status",
          "projectOwner": "Project Owner",
          "createdOn": "Date Created",
          "actions": "Actions"
        },
        "values": {
          "active": "Active",
          "inactive": "Inactive",
          "archived": "Archived",
          "addProject": "Add Project",
          "filters": "Filters",
          "newComments": "New Comments",
          "projectLimitReached": "Project limit reached."
        },
        "actions": {
          "editProjectSettings": "Edit Project Settings",
          "duplicateProject": "Duplicate Project",
          "preview": "Preview",
          "deleteProject": "Delete Project",
          "archiveProject": "Archive Project"
        }
      },
      "overview": {
        "statusBannerLabels": {
          "title": "Phase Settings",
          "changeSettingsButton": "Change Settings",
          "activePhase": "Active Phase",
          "status": "Status",
          "dateCollectionPeriod": "Date Collection Period",
          "commentsActive": "Comments Active",
          "surveyActive": "Survey Active",
          "previewSite": "Preview Site"
        },
        "firstPhaseSetup": {
          "headerLabel": "Let's set up your first phase!",
          "message": "Now we're going to help guide you through setting up your first phase. Phases help organize your settings and feedback so that you can add another phase in the future without impacting any feedback you've previously collected.",
          "continue": "Continue"
        },
        "metrics": {
          "header": "Project Insights",
          "filter": {
            "label": "Filter",
            "mapView": "Map View",
            "allMapViews": "All"
          },
          "totalComments": {
            "label": "Total Comments",
            "tooltip": "Total number of map comments the project has received in its current phase."
          },
          "newComments": {
            "label": "New Comments",
            "tooltip": "Number of new comments since yesterday."
          },
          "unmoderatedComments": {
            "label": "Unmoderated Comments",
            "tooltip": "Number of comments that have been flagged as needing review. These comments will not be made public to other users until moderated."
          },
          "commentCategories": {
            "label": "Comment Categories",
            "tooltip": "This is a current breakdown of comments collected by category.",
            "noData": "No data to display",
            "table": {
              "headers": {
                "commentCategory": "Comment Category",
                "numberOfComments": "Number of Comments",
                "percentage": "Percentage"
              }
            }
          },
          "sentimentAnalysis": {
            "label": "AI-Assisted Sentiment Analysis",
            "tooltip": "This is a current breakdown of comments based on sentiment. Please note this breakdown was generated by AI.",
            "noData": "No data to display",
            "table": {
              "headers": {
                "sentimentCategory": "Sentiment Category",
                "numberOfComments": "Number of Comments",
                "percentage": "Percentage"
              },
              "filter": "Filter",
              "commentCategory": "Comment Category",
              "allCategories": "All Comment Categories"
            }
          },
          "commentSummary": {
            "label": "AI-Assisted Summarization",
            "tooltip": "This is a current summarization of comments based on sentiment. Please note this breakdown was generated by AI and may not cover all details or nuances in collected feedback.",
            "noData": "No data to display",
            "filter": "Filter",
            "commentCategory": "Comment Category",
            "allCategories": "All Comment Categories"
          }
        }
      },
      "surveys": {
        "header": {
          "header": "Survey",
          "externalSubheader": "Embed a survey hosted on an external platform to collect responses within your project. Notably, you will manage all collected data directly through the third party's platform. If you wish to create a survey within PublicCoordinate, change your survey settings.",
          "internalSubheader": "Create and manage a survey to collect structured feedback from your community. Add questions, organize survey content, and preview the experience visitors will see when responding. If you wish to use a third party survey, change your survey settings."
        },
        "table": {
          "headers": {
            "dateSubmitted": "Date Submitted"
          },
          "actions": {
            "filters": "Filters",
            "export": "Export"
          },
          "notifications": {
            "responsesExported": "Survey responses have been exported"
          }
        },
        "preview": {
          "header": "Survey Preview",
          "previewMessage": "You are currently in Preview Mode.",
          "controls": {
            "viewport": {
              "ariaLabel": "Viewport",
              "desktop": "Desktop",
              "tablet": "Tablet",
              "mobile": "Mobile"
            }
          }
        },
        "setup": {
          "header": "Survey Setup",
          "emptyStateLabel": "You currently have no selected survey type. Configure the survey settings."
        },
        "embed": {
          "form": {
            "fields": {
              "embedType": {
                "label": "To embed a third-party survey in your map, select the type of embed code you're using.",
                "options": {
                  "iframe": "iframe",
                  "script": "script"
                }
              },
              "codeSnippet": {
                "label": "Code Snippet",
                "placeholder": "Paste your survey embed code here",
                "hint": "Extracted Survey Url: {{surveyExternalUrl}}"
              }
            }
          }
        },
        "surveySettings": {
          "header": {
            "title": "Survey Settings",
            "changeSettingsButton": "Change Settings",
            "previewSurveyButton": "Preview Survey"
          },
          "content": {
            "external": "Embeddable Survey",
            "externalType": "Embed Type",
            "iframe": "iframe",
            "script": "script",
            "externalSurveyHostname": "Survey Provider",
            "internal": "Survey Builder",
            "surveyType": "Survey Type",
            "unknown": "Not Configured"
          },
          "dialog": {
            "internal": "Survey Builder",
            "internalDescription": "The survey builder in PublicCoordinate covers your basic survey needs, allowing your data to stay within PublicCoordinate and not rely on a 3rd party tool.",
            "external": "Embeddable Survey",
            "externalDescription": "Embedding a 3rd party survey tool is best when advanced features such as complex question types or conditional logic are needed.",
            "switchToExternalWarning": "Switching the survey type will delete any existing survey setup and responses. This action cannot be undone. Are you sure you wish to switch to an embedded survey?",
            "switchToInternalWarning": "Switching the survey type will disconnect your current embedded third party survey from the PublicCoordinate map. Are you sure you wish to switch to the custom survey builder?"
          },
          "notifications": {
            "updateSurveySettingsSuccess": "Survey settings have been updated",
            "updateSurveySettingsFailed": "Error updating survey settings"
          }
        },
        "surveysDisabledContent": {
          "disabledClickableText": "here.",
          "disabledHeader": "Surveys for this phase have been disabled.",
          "disabledText": "You can edit Phase Settings ",
          "externalSurveyHeader": "No survey data to report.",
          "externalSurveyText": "If you are using a third-party survey tool to collect data, please manage your responses directly within that platform.",
          "internalSurveyText": "You have not collected any survey responses yet. Once you have survey responses, they will show up here."
        }
      },
      "commentCategories": {
        "setup": {
          "header": "Comment Categories",
          "subheader": "Comment categories help organize feedback submitted by map visitors. Create and manage your comment categories to guide how community input is labeled and displayed across all map views within this phase.",
          "table": {
            "empty": "You currently have no Comment Categories.",
            "actions": {
              "addNew": "New Category",
              "edit": "Edit Category",
              "delete": "Delete Category"
            },
            "columns": {
              "category": "Category",
              "actions": "Actions"
            }
          },
          "removeDialog": {
            "header": "Remove Comment Category",
            "message": "Are you sure you wish to remove this comment category?",
            "removeSuccess": "Comment category has been successfully removed.",
            "removeFailed": "Error deleting comment category"
          },
          "commentSettings": {
            "header": {
              "title": "Comment Settings",
              "changeSettingsButton": "Change Settings"
            },
            "content": {
              "visitorEmailCaptureStatus": "Visitor Email Capture Status:",
              "enableCommentReplies": "Enable Comment Replies:",
              "enableUploadingImages": "Enable Uploading Images:",
              "enableCommentVoting": "Enable Comment Voting:",
              "enableVoteCount": "Show Vote Count:",
              "anonymous": "Anonymous",
              "emailRequired": "Email Required",
              "emailOptional": "Email Optional",
              "unknown": "Unknown",
              "yes": "Yes",
              "no": "No"
            },
            "dialog": {
              "anonymityLabel": "Visitor Email Capture Status",
              "enableRepliesLabel": "Enable Comment Replies",
              "enableImageUploadLabel": "Enable Uploading Images",
              "enableCommentVotingLabel": "Enable Comment Voting",
              "showVoteCountsLabel": "Show Vote Counts",
              "yes": "Yes",
              "no": "No"
            },
            "notifications": {
              "updateCommentSettingsSuccess": "Comment settings have been updated",
              "updateCommentSettingsFailed": "Error updating comment settings"
            }
          }
        },
        "addCommentCategory": {
          "header": "Select Comment Category Type",
          "subheader": "These are what visitors will see when leaving comments on the map.",
          "actions": {
            "next": "Next",
            "cancel": "Cancel"
          },
          "point": {
            "title": "Point",
            "textContent": "A Point Comment is used to draw attention to a specific point of interest.",
            "exampleName": "Public Transport Concern"
          },
          "line": {
            "title": "Line",
            "textContent": "A Line Comment is used for straight lines or multiple straight lines connected together.",
            "exampleName": "Walking Path Idea"
          }
        },
        "commentCategoryForm": {
          "add": {
            "lineHeader": "Add Line Category",
            "pointHeader": "Add Point Category"
          },
          "edit": {
            "lineHeader": "Edit Line Category",
            "pointHeader": "Edit Point Category"
          },
          "form": {
            "fields": {
              "categoryName": {
                "label": "Category Name"
              },
              "categoryDescription": {
                "label": "Category Description"
              },
              "lineSettings": {
                "lineColor": {
                  "label": "Line Color"
                },
                "lineWidth": {
                  "label": "Line Width"
                },
                "lineOpacity": {
                  "label": "Line Opacity"
                },
                "lineStyle": {
                  "label": "Line Style",
                  "options": {
                    "solid": "Solid",
                    "dotted": "Dotted",
                    "dashed": "Dashed"
                  }
                },
                "advancedOptions": {
                  "label": "Advanced Options",
                  "note": "Changing settings in this section may cause the line to not meet accessibility standards."
                }
              },
              "pointSettings": {
                "advancedOptions": {
                  "label": "Advanced Options",
                  "note": "Changing settings in this section may cause the point to not meet accessibility standards."
                },
                "size": {
                  "label": "Size",
                  "options": {
                    "small": "Small",
                    "medium": "Medium",
                    "large": "Large"
                  }
                },
                "iconName": {
                  "label": "Search Icons",
                  "placeholder": "Search Icons"
                },
                "iconFill": {
                  "label": "Use Filled Icons"
                },
                "iconColor": {
                  "label": "Icon Color",
                  "options": {
                    "white": "White",
                    "black": "Black"
                  }
                },
                "backgroundColor": {
                  "label": "Background Color"
                },
                "backgroundOpacity": {
                  "label": "Background Opacity"
                },
                "borderColor": {
                  "label": "Border Color"
                },
                "borderWidth": {
                  "label": "Border Width"
                },
                "borderOpacity": {
                  "label": "Border Opacity"
                }
              }
            }
          }
        }
      },
      "comments": {
        "thread": {
          "header": "Commenting as"
        },
        "table": {
          "headers": {
            "comment": "Comment",
            "replies": "Replies",
            "commentCategory": "Comment Category",
            "mapViewName": "Map View",
            "lastReply": "Last Reply"
          },
          "actions": {
            "filters": "Filters",
            "export": "Export",
            "viewMap": "View Map",
            "listView": "List",
            "mapView": "Map"
          }
        },
        "actions": {
          "approve": "Publish Comment",
          "reject": "Unpublish Comment",
          "delete": "Delete Comment"
        },
        "commentDeletion": {
          "header": "Delete Comment?",
          "subheader": "Are you sure you want to delete this comment?",
          "confirmationMessage": "Please type the project name to confirm."
        },
        "moderationStatus": {
          "needsReview": "Needs Review",
          "published": "Published",
          "rejected": "Not Published"
        },
        "notifications": {
          "commentsExported": "Comments exported",
          "approveSuccess": "Comment has been published",
          "approveFailed": "Failed to publish comment",
          "rejectSuccess": "Comment has been unpublished",
          "rejectFailed": "Failed to unpublish comment",
          "deleteSuccess": "Comment has been deleted",
          "deleteFailed": "Failed to delete comment"
        },
        "commentsDisabledContent": {
          "header": "Comments for this phase have been disabled.",
          "text": "You can edit Comment Settings ",
          "clickableText": "here."
        },
        "noCommentsContent": {
          "header": "No Comments to Report.",
          "text": "You have not collected any comments on your map yet. Once you have comments, they will show up here."
        },
        "reply": {
          "form": {
            "fields": {
              "replyText": {
                "label": "Reply"
              },
              "upload": {
                "label": "Upload File",
                "hint": "PDF, SVG, PNG, JPG or GIF (max. 3MB)"
              }
            },
            "actions": {
              "addHyperlinkAriaLabel": "Add hyperlink",
              "replyButtonLabel": "Reply",
              "clearButtonLabel": "Clear"
            }
          },
          "notifications": {
            "replySubmitted": "Reply has been submitted."
          }
        },
        "translation": {
          "seeTranslation": "See Translation",
          "seeOriginal": "See Original",
          "translate": "Translate"
        }
      },
      "formBlocks": {
        "longAnswer": {
          "staticLabels": {
            "textQuestion": "Enter Answer"
          }
        },
        "shortAnswer": {
          "staticLabels": {
            "textQuestion": "Enter Answer"
          }
        }
      },
      "formBuilder": {
        "titleBlock": {
          "title": "Survey Title",
          "emptyStateLabel": "Title will not be shown",
          "form": {
            "label": "Title"
          },
          "dialog": {
            "header": "Edit Title",
            "form": {
              "label": "Title"
            },
            "removeTitle": {
              "header": "Remove Title",
              "confirmation": "Are you sure you want to remove the title?"
            }
          },
          "controls": {
            "edit": "Edit title",
            "delete": "Delete title"
          }
        },
        "surveyInformation": {
          "dialog": {
            "header": "Edit Information Block"
          }
        },
        "newBlock": {
          "blockTypeLabels": {
            "Information": "Information Block",
            "LongAnswer": "Long Answer Question",
            "Matrix": "Matrix Question",
            "MultipleChoice": "Multi Select Question",
            "ShortAnswer": "Short Answer Question",
            "SingleChoice": "Single Select Question"
          },
          "newBlockButtonLabel": "New Question"
        },
        "questionBlock": {
          "Title": {
            "header": "Title"
          },
          "Information": {
            "header": "Information",
            "controls": {
              "actions": {
                "label": "More options",
                "edit": "Edit Information Block",
                "duplicate": "Duplicate Information Block",
                "moveDown": "Move down",
                "moveUp": "Move up",
                "delete": "Delete Information Block"
              },
              "dragAriaLabel": "Drag to reorder block"
            },
            "dialog": {
              "removeBlock": {
                "header": "Delete Information Block",
                "confirmation": "Are you sure you want to delete this information block?"
              }
            }
          },
          "LongAnswer": {
            "header": "Long Answer Question",
            "controls": {
              "actions": {
                "label": "More options",
                "edit": "Edit question",
                "duplicate": "Duplicate Question",
                "moveDown": "Move down",
                "moveUp": "Move up",
                "delete": "Delete question"
              },
              "dragAriaLabel": "Drag to reorder question"
            },
            "dialog": {
              "removeBlock": {
                "header": "Delete Question",
                "confirmation": "Are you sure you want to delete this long answer question?"
              }
            }
          },
          "Matrix": {
            "header": "Matrix Questions",
            "controls": {
              "actions": {
                "label": "More options",
                "edit": "Edit Questions",
                "moveDown": "Move down",
                "moveUp": "Move up",
                "delete": "Delete Questions"
              },
              "dragAriaLabel": "Drag to reorder questions"
            },
            "dialog": {
              "removeBlock": {
                "header": "Delete Questions",
                "confirmation": "Are you sure you want to delete this group of questions?"
              }
            }
          },
          "MultipleChoice": {
            "header": "Multi Select Question",
            "controls": {
              "actions": {
                "label": "More options",
                "edit": "Edit Question",
                "duplicate": "Duplicate Question",
                "moveDown": "Move down",
                "moveUp": "Move up",
                "delete": "Delete Question"
              },
              "dragAriaLabel": "Drag to reorder question"
            },
            "dialog": {
              "removeBlock": {
                "header": "Delete Question",
                "confirmation": "Are you sure you want to delete this multi select question?"
              }
            }
          },
          "ShortAnswer": {
            "header": "Short Answer Question",
            "controls": {
              "actions": {
                "label": "More options",
                "edit": "Edit Question",
                "duplicate": "Duplicate Question",
                "moveDown": "Move down",
                "moveUp": "Move up",
                "delete": "Delete Question"
              },
              "dragAriaLabel": "Drag to reorder question"
            },
            "dialog": {
              "removeBlock": {
                "header": "Delete Question",
                "confirmation": "Are you sure you want to delete this short answer question?"
              }
            }
          },
          "SingleChoice": {
            "header": "Single Select Question",
            "controls": {
              "actions": {
                "label": "More options",
                "edit": "Edit Question",
                "duplicate": "Duplicate Question",
                "moveDown": "Move down",
                "moveUp": "Move up",
                "delete": "Delete Question"
              },
              "dragAriaLabel": "Drag to reorder question"
            },
            "dialog": {
              "removeBlock": {
                "header": "Delete Question",
                "confirmation": "Are you sure you want to delete this single select question?"
              }
            }
          }
        },
        "notifications": {
          "createFormBlockFailed": "Error creating survey block",
          "formBlockedSaved": "Your changes have been saved",
          "minOptionsError": "At least two options are required.",
          "removeFormBlockFailed": "Error removing survey question",
          "removeFormBlockSuccess": "Survey question has been removed",
          "removeFormBlockTitleFailed": "Error removing survey title",
          "removeFormBlockTitleSuccess": "Survey title have been removed",
          "updateFormBlockFailed": "Error updating survey block",
          "updateFormBlockTitleFailed": "Error updating survey title",
          "updateFormBlockTitleSuccess": "Survey title have been updated",
          "copyFormBlockFailed": "Error saving your changes"
        },
        "emptyStateLabel": "You currently have no selected survey type. Configure the survey settings.",
        "editor": {
          "header": "Edit Question",
          "form": {
            "fields": {
              "questionText": {
                "label": "Question",
                "required": "Question is required"
              },
              "questionDescriptionText": {
                "label": "Question Description"
              },
              "rows": {
                "label": "Row {{index}}",
                "addRow": "Add Row",
                "deleteAriaLabel": "Remove Row {{index}}",
                "disabledDeleteRow": "This question type needs a minimum of two rows.",
                "removeDialog": {
                  "header": "Remove Row",
                  "message": "Are you sure you wish to remove this row?",
                  "removeSuccess": "Row has been successfully removed.",
                  "removeFailed": "Error deleting row."
                }
              },
              "columns": {
                "label": "Column {{index}}",
                "addColumn": "Add Column",
                "deleteAriaLabel": "Remove Column {{index}}",
                "disabledDeleteOption": "This question type needs a minimum of two columns for respondents to select from.",
                "removeDialog": {
                  "header": "Remove Column",
                  "message": "Are you sure you wish to remove this column?",
                  "removeSuccess": "Column has been successfully removed.",
                  "removeFailed": "Error deleting column."
                }
              },
              "options": {
                "label": "Option {{index}}",
                "addOption": "Add Option",
                "deleteAriaLabel": "Remove Option {{index}}",
                "minLessThanZero": "Selection minimum must be at least 0.",
                "maxLessThanOne": "Selection maximum must be at least 1.",
                "maxMoreThanOptions": "Selection maximum cannot exceed number of options.",
                "maxLessThanMin": "Selection maximum must be greater than or equal to selection minimum of {{min}}.",
                "minGreaterThanOptions": "Selection minimum cannot exceed number of options.",
                "disabledDeleteOption": "This question type needs a minimum of two options for respondents to select from.",
                "optionText": "Option Text",
                "optionTextRequired": "Option text is required",
                "statementText": "Statement Text",
                "statementTextRequired": "Statement text is required",
                "columnText": "Column Text",
                "columnTextRequired": "Column text is required",
                "removeDialog": {
                  "header": "Remove Option",
                  "message": "Are you sure you wish to remove this option?",
                  "removeSuccess": "Option has been successfully removed.",
                  "removeFailed": "Error deleting option."
                }
              },
              "required": {
                "label": "Required"
              }
            }
          },
          "questionTypes": {
            "shortAnswer": {
              "form": {
                "fields": {
                  "placeholderText": {
                    "label": "Enter Answer"
                  }
                }
              }
            },
            "longAnswer": {
              "form": {
                "fields": {
                  "placeholderText": {
                    "label": "Enter Answer"
                  }
                }
              }
            },
            "singleChoice": {
              "form": {
                "fields": {
                  "radioOptions": {
                    "label": "Radio Options"
                  }
                }
              }
            },
            "multipleChoice": {
              "form": {
                "fields": {
                  "selectionMinimum": "Selection Min.",
                  "selectionMaximum": "Selection Max.",
                  "options": {
                    "label": "Checkbox Options"
                  }
                }
              }
            },
            "matrix": {
              "form": {
                "fields": {
                  "rows": {
                    "label": "Rows"
                  },
                  "columns": {
                    "label": "Columns"
                  }
                }
              }
            },
            "information": {
              "form": {
                "fields": {
                  "htmlContent": {
                    "label": "Content"
                  }
                }
              }
            }
          }
        },
        "requiredFieldLabel": "Required fields"
      },
      "translations": {
        "header": "Translations",
        "subheader": "Adding translations allows you to enable inclusive feedback by manually controlling the translated content that your project audience can select and view. The default language will be used, unless the user personally selects their prefered language from within the browser.",
        "addTranslation": {
          "button": "Add Translation",
          "header": "Add Translation",
          "successMessage": "Translation has been successfully added.",
          "form": {
            "fields": {
              "language": {
                "label": "Language",
                "placeholder": "Select Language"
              }
            }
          },
          "actions": {
            "add": "Add Translation",
            "cancel": "Cancel"
          }
        },
        "removeTranslation": {
          "header": "Delete Translation",
          "message": "Are you sure you want to delete the {{ translation }} translation from the project?",
          "removeSuccess": "Translation has been successfully deleted.",
          "removeFailed": "Error deleting translation."
        },
        "tabs": {
          "translationsList": "Translations",
          "manageTranslatedContent": "Manage Translated Content"
        },
        "table": {
          "headers": {
            "languageCode": "Language Code",
            "displayAs": "Display As",
            "actions": "Actions"
          },
          "actions": {
            "delete": "Delete",
            "disabledDeleteTooltip": "The default translation cannot be deleted. Please set another translation as the default first."
          },
          "default": "Default",
          "empty": "No translations have been added yet."
        },
        "mapTranslations": {
          "table": {
            "headers": {
              "legend": "Legend Display Name",
              "nameTranslated": "Translated as",
              "description": "Description",
              "descriptionTranslated": "Translated as",
              "actions": "Actions",
              "tooltips": {
                "nameTranslated": "AI-generated translation of the 'Legend Display Name' (may require review).",
                "descriptionTranslated": "AI-generated translation of the 'Description' (may require review)."
              }
            },
            "actions": {
              "reset": "Reset translation"
            }
          }
        },
        "manageTranslatedContent": {
          "languageSelection": "Select Language Translation",
          "languageSelectionSingleTooltip": "Only one language has been configured",
          "phaseSelectorEditModeTooltip": "You are currently in edit mode. You can change Phases once you are not.",
          "pageSelection": "Select Page",
          "emptyState": {
            "title": "Add a language to start managing translated content",
            "description": "Once you add another language in Translations, you'll be able to manage the translated content your public users see, all in one place."
          }
        },
        "commentCategoryTranslations": {
          "table": {
            "headers": {
              "categoryName": "Category Name",
              "translatedAs": "Translated as",
              "description": "Description",
              "descriptionTranslated": "Translated as",
              "actions": "Actions",
              "tooltips": {
                "translatedAs": "AI-generated translation of the 'Category Name' (may require review).",
                "descriptionTranslated": "AI-generated translation of the 'Description' (may require review)."
              }
            },
            "actions": {
              "reset": "Reset translation"
            }
          }
        },
        "projectPageTranslations": {
          "header": "Project Header",
          "comingSoon": "Translations for the body, welcome message, and files section are coming soon."
        }
      },
      "phases": {
        "table": {
          "headers": {
            "phase": "Phase",
            "status": "Status",
            "dataCollectionPeriod": "Data Collection Period",
            "comments": "Total Comments",
            "actions": "Actions"
          },
          "values": {
            "active": "Active",
            "inactive": "Inactive",
            "addPhase": "Add Phase",
            "present": "Present"
          },
          "actions": {
            "exportFeedback": "Export Feedback",
            "phaseSettings": "Phase Settings",
            "commentCategories": "Comment Categories",
            "mapsAndLayers": "Maps & Layers"
          }
        },
        "addPhase": {
          "header": "Create a New Phase",
          "subheader": "Phases are used to capture and safeguard the valuable feedback captured by the app. A new phase starts a new feedback gathering cycle without touching data in other phases so you can refer back to it later.",
          "actions": {
            "next": "Continue",
            "cancel": "Cancel"
          },
          "copy": {
            "title": "Copy Previous Phase",
            "subtitle": "You choose what to copy",
            "textContent": "Copies over all selected setup information from the previous phase including Comment Categories, Map Layers, and Surveys. It does not copy over any feedback gathered during the previous phase."
          },
          "blank": {
            "title": "Blank Phase",
            "subtitle": "You want a fresh start",
            "textContent": "A Blank Phase gives you a clean state allowing you to pivot mid-project to tackle the most critical need based on the previously gathered feedback. All your previous information is not touched."
          }
        },
        "projectPageExperience": {
          "header": "Create a New Phase",
          "subheader": "Choose the project page experience for this phase",
          "actions": {
            "back": "Back",
            "cancel": "Cancel",
            "next": "Continue"
          },
          "new": {
            "title": "New Project Page Experience",
            "subtitle": "Upgrade to the new project page",
            "textContent": "This phase gets its own page built with the new project page builder. Every phase you create from now on will also use the New Project Page Experience. Your existing phases keep the Legacy Project Page Experience."
          },
          "legacy": {
            "title": "Legacy Project Page Experience",
            "subtitle": "Keep the project page you have today",
            "textContent": "This phase shares the same project page as your existing phases. You can still upgrade the next time you create a phase."
          }
        },
        "copyPhase": {
          "header": "Create a New Phase",
          "form": {
            "subheader": "Choose what to copy over from the previous phase",
            "note": "Note: No feedback data will be copied from the phase, only settings.",
            "fields": {
              "projectPhaseToCopy": {
                "label": "Select phase",
                "placeholder": "Select phase to copy"
              },
              "commentCategories": {
                "label": "Comment Categories",
                "infoText": "Copies all Comment Categories and their respective styles."
              },
              "mapsAndLayers": {
                "label": "Maps & Views",
                "infoText": "Copies the Map Style settings and Map Views along with their respective layers."
              },
              "surveySetup": {
                "label": "Survey Setup",
                "infoText": "Copies over the survey settings."
              },
              "projectPage": {
                "label": "Project Page",
                "infoText": "Copies over the Project Page layout."
              }
            }
          },
          "actions": {
            "next": "Continue",
            "back": "Back",
            "cancel": "Cancel"
          }
        },
        "phaseCreated": {
          "header": "New phase created!",
          "question": "Do you want to see the New Phase Set Up tile on the Overview page?",
          "actions": {
            "continue": "Continue"
          }
        },
        "settings": {
          "dialog": {
            "header": "Phase Settings",
            "setPhaseToActiveLabel": "Set Phase to Active",
            "dataCollectionWarningText": "Any active data collection in other phases will be stopped. Are you sure you want to enable data collection for this phase?",
            "enableCommentsLabel": "Enable Comments",
            "enableSurveyLabel": "Enable Survey Responses",
            "collectionPeriodLabel": "Data Collection Period",
            "collectionPeriodStartLabel": "Start Date",
            "collectionPeriodEndLabel": "End Date",
            "peopleFieldSectionLabel": "Do you want to receive daily comment summaries?",
            "peopleFieldLabel": "People",
            "peopleFieldHint": "Not seeing who you're looking for? You might need to ",
            "peopleFieldHintClickableText": "invite them to PublicCoordinate."
          }
        }
      },
      "collaborators": {
        "header": "Collaborators",
        "subheader": "Collaborators are team members who have access to manage, edit, or view this project. Add collaborators and assign roles to control who can edit project content, review feedback, and manage project settings.",
        "table": {
          "headers": {
            "displayName": "Name",
            "emailAddress": "Email",
            "actions": "Actions",
            "roles": "Role"
          },
          "values": {
            "addCollaborator": "Add Collaborator",
            "addCollaboratorHeader": "Add Collaborator to ",
            "addCollaboratorPlaceholder": "Search for a collaborator",
            "addCollaboratorHint": "Not seeing who you're looking for? You might need to ",
            "addCollaboratorHintClickableText": "invite them.",
            "collaboratorAdded": "User added!",
            "chooseCollaborator": "Choose Collaborator(s)",
            "searchCollaborator": "Search for a collaborator",
            "removeCollaborator": "Remove from Project",
            "removeCollaboratorConfirmation": "Are you sure you wish to remove the following collaborator from the project?",
            "removeCollaboratorTitle": "Remove Collaborator",
            "filters": "Filters",
            "editProjectRole": "Edit Role"
          }
        },
        "notifications": {
          "removeCollaboratorSuccess": "Collaborator successfully removed",
          "removeCollaboratorFailed": "Remove collaborator failed",
          "editProjectRoleSuccess": "User role successfully updated",
          "editProjectRoleFailed": "User role failed to update"
        },
        "roles": {
          "projectAdministrator": "Project Administrator",
          "projectContributor": "Project Contributor",
          "projectViewer": "Project Viewer"
        },
        "editProjectRole": {
          "label": "Edit {{ projectUserName }} Role from {{ projectName }}",
          "selectRole": "Select Project Role",
          "buttonText": "Save"
        }
      },
      "setupWizard": {
        "header": "Let's set up your first phase!",
        "steps": {
          "projectUsers": {
            "description": "Invite others to help manage your project and data collection.",
            "label": "Add Collaborators"
          },
          "mapsViews": {
            "description": "Add your features and choose your map style",
            "label": "Build Your Map"
          },
          "commentCategories": {
            "description": "Choose comment categories and the style that fits your project",
            "label": "Customize Comment Categories"
          },
          "projectPage": {
            "description": "Provide some basic info to get your site up and running",
            "label": "Setup Project Page"
          },
          "survey": {
            "description": "Want to capture more information? Add a survey.",
            "label": "Add a Survey"
          },
          "preview": {
            "description": "See what others are going to see",
            "label": "Preview Your Work"
          },
          "share": {
            "description": "You've done it! Share your work with the rest of the world!",
            "label": "Share",
            "dialog": {
              "header": "Share",
              "subheader": "Use the links below to share your work!"
            }
          }
        }
      },
      "projectCreation": {
        "header": "How do you wish to get started?",
        "subheader": "Choose a starting point for your new project.",
        "actions": {
          "next": "Next",
          "cancel": "Cancel"
        },
        "blank": {
          "label": "Select for blank project",
          "title": "Blank Project",
          "subtitle": "Your project, your way",
          "textContent": "We'll still provide you a couple of basics to help you get your project up and running quickly, but beyond that it's a blank canvas for you to create.",
          "form": {
            "header": "New Project",
            "subheader": "Give us some details about your new project.",
            "projectName": "Project Name",
            "urlSlug": "URL Name",
            "billingAccount": "Billing Account",
            "projectOwner": "Project Owner",
            "urlPreview": "URL Preview",
            "country": "In what country is the project located?",
            "language": "What is the primary language for this project?",
            "actions": {
              "back": "Back",
              "save": "Save",
              "cancel": "Cancel"
            }
          }
        },
        "existing": {
          "label": "Select for existing project",
          "title": "Existing Project",
          "subtitle": "Pull settings from an existing project",
          "textContent": "Already have a project setup the way you want it but want to tweak a few things? This is the path for you. We'll bring over settings and leave the data alone.",
          "form": {
            "header": "Copy Existing Project",
            "subheader": "Choose what to copy from the existing project.",
            "projectToCopy": "Project to Copy",
            "projectName": "New Project Name",
            "projectOwner": "Project Owner",
            "urlSlug": "URL Name",
            "billingAccount": "Billing Account",
            "language": "Language",
            "country": "Country",
            "copySelections": {
              "header": "Choose what project setup information you'd like to carry over.",
              "commentCategories": {
                "header": "Comment Categories",
                "infoText": "Copies all comment categories and their respective styles. "
              },
              "collaborators": {
                "header": "Collaborators",
                "infoText": "Adds existing collaborators to new project."
              },
              "surveySetup": {
                "header": "Survey Setup",
                "infoText": "Copies over the survey settings."
              },
              "siteSetup": {
                "header": "Project Site Setup",
                "infoText": "Copies over project site settings and information."
              }
            },
            "actions": {
              "back": "Back",
              "save": "Save",
              "cancel": "Cancel"
            }
          }
        }
      },
      "projectDeletion": {
        "header": "Delete {{projectName}}?",
        "subheader": "Are you sure you want to delete {{projectName}}? The project information will be permanently deleted and you will no long be able to access the project.",
        "confirmationMessage": "Please type the project name to confirm.",
        "confirmationLabel": "Project Name",
        "deleteButtonLabel": "Delete",
        "errorMatchNameMessage": "Project name does not match.",
        "errorNotification": "Error deleting project.",
        "successNotification": "Project deleted successfully."
      },
      "editProjectInfo": {
        "form": {
          "header": "Edit Project Info",
          "subheader": "Give us some details about your project."
        },
        "notifications": {
          "updateProjectSuccess": "Your settings have been saved"
        },
        "tabs": {
          "projectPage": "Project Page",
          "embeddableMap": "Embeddable Map"
        }
      },
      "share": {
        "projectPage": {
          "projectPageUrlLabel": "Project Page URL",
          "copyProjectPageUrlLabel": "Copy",
          "copiedProjectPageUrl": "Copied Project Page URL to clipboard",
          "qrCodeLabel": "QR Code",
          "downloadQrCodeButton": "Download QR Code"
        },
        "embeddableMap": {
          "embeddableMapUrlLabel": "Embeddable Map URL",
          "copyMapUrlLabel": "Copy map URL",
          "copiedMapUrl": "Copied Map URL to clipboard",
          "embedCodeLabel": "Embed code",
          "copyEmbedCodeLabel": "Copy Embed code",
          "copiedEmbedCode": "Copied Embed code to clipboard",
          "qrCodeLabel": "QR Code",
          "downloadQrCodeButton": "Download map only QR Code"
        }
      },
      "projectPageCmsBuilder": {
        "header": "Project Page",
        "subheader": "Your Project Page is the public page visitors see when they open your project. Configure the header and content below, then use Preview Mode to check how it will look on desktop, tablet, and mobile.",
        "headerBlock": {
          "headerText": "Project Header",
          "emptyStateText": "Click here to configure your header",
          "fields": {
            "logo": {
              "hint": "SVG, PNG, JPG or GIF"
            },
            "title": {
              "label": "Page Title"
            }
          }
        },
        "addSectionButton": "Add Element",
        "addElementMenu": {
          "section": "Section",
          "divider": "Divider"
        },
        "section": {
          "label": "Section",
          "dividerLabel": "Divider",
          "mapLabel": "Map",
          "addWidgetButton": "Add Content",
          "moveUp": "Move section up",
          "moveDown": "Move section down",
          "deleteSection": "Delete section",
          "dividerStrokeWidth": {
            "label": "Divider thickness",
            "Small": "Thin",
            "Medium": "Medium",
            "Large": "Thick"
          },
          "dividerLineStyle": {
            "label": "Divider line style",
            "Solid": "Solid",
            "Dashed": "Dashed"
          },
          "empty": "This section is empty. Add a widget to get started.",
          "deleteDialog": {
            "header": "Delete this section?",
            "message": "This will permanently delete this section and all content in it. This can't be undone."
          }
        },
        "addTextMenuItem": "Text",
        "addFileMenuItem": "File",
        "addImageMenuItem": "Image",
        "addSurveyMenuItem": "Survey",
        "addProgressChecklistMenuItem": "Progress Checklist",
        "addEventBoardMenuItem": "Event Board",
        "addTitleMenuItem": "Title",
        "widgetType": {
          "Text": "Text",
          "File": "File",
          "Map": "Map",
          "Survey": "Survey",
          "Image": "Image",
          "Divider": "Divider",
          "ProgressChecklist": "Progress Checklist",
          "EventBoard": "Event Board",
          "Title": "Title"
        },
        "mapWidget": {
          "placeholderAlt": "Preview of the map that will appear here on the published page.",
          "placeholderTooltip": "This is not your actual map, just a placeholder for where it will render on your page."
        },
        "deleteWidget": "Delete widget",
        "dragWidget": "Drag to reposition",
        "editWidget": "Edit widget",
        "doneEditingWidget": "Done editing",
        "noFiles": "No files have been added yet.",
        "noImages": "No images have been added yet.",
        "textWidget": {
          "titleLabel": "Section heading"
        },
        "fileWidget": {
          "titleLabel": "Section heading",
          "fileActions": "Actions for {{fileName}}",
          "openInNewTab": "Open in new tab",
          "download": "Download",
          "displayNameLabel": "Display name",
          "uploadedFilesLabel": "Uploaded files",
          "uploadHint": "Max. 15MB",
          "supportedFileTypesTooltip": "Supported file types: PDF, images (PNG, JPG, GIF, WebP), Word, Excel, PowerPoint, OpenDocument, RTF, plain text, CSV, and ZIP."
        },
        "imageWidget": {
          "titleLabel": "Section heading",
          "uploadHintStatic": "Upload one image (PNG, JPG, GIF or WEBP) to show it as a static image.",
          "uploadHintCarousel": "Upload multiple images to show them in a carousel.",
          "carouselLabel": "Image carousel",
          "slideLabel": "Image {{index}} of {{count}}",
          "previousImage": "Previous image",
          "nextImage": "Next image",
          "goToImage": "Go to image {{index}} of {{count}}",
          "slidePickerLabel": "Choose an image",
          "uploadedImagesLabel": "Uploaded images",
          "altTextLabel": "Alt text",
          "altTextHint": "Describe what the image shows for people using a screen reader.",
          "missingAltText": "Alt text is required. {{count}} image(s) won't be saved to the published page until alt text is added.",
          "saveAltTextFailed": "The alt text could not be saved. Please try again."
        },
        "titleWidget": {
          "textLabel": "Title",
          "placeholder": "Click to add a title",
          "styleLabel": "Text style",
          "bold": "Bold",
          "italic": "Italic",
          "underline": "Underline",
          "alignmentLabel": "Text alignment",
          "alignLeft": "Align left",
          "alignCenter": "Align center",
          "alignRight": "Align right",
          "colorLabel": "Text color",
          "fontSizeLabel": "Font size"
        },
        "surveyWidget": {
          "titleLabel": "Section heading",
          "alignmentLabel": "Button alignment",
          "alignLeft": "Align left",
          "alignCenter": "Align center",
          "alignRight": "Align right"
        },
        "progressChecklistWidget": {
          "titleLabel": "Section heading",
          "previewLabel": "Completed phase",
          "iconLabel": "Icon",
          "iconPlaceholder": "Search icons",
          "backgroundColorLabel": "Completed color",
          "phasesLabel": "Phases",
          "phaseNameLabel": "Phase name",
          "completeLabel": "Complete",
          "addPhase": "Add phase",
          "unnamedPhase": "New phase",
          "deletePhase": "Delete phase {{name}}",
          "phaseComplete": "Completed phase",
          "phaseIncomplete": "Upcoming phase",
          "empty": "No phases yet. Select the widget to add phases."
        },
        "eventBoardWidget": {
          "titleLabel": "Section heading",
          "eventLabel": "Event",
          "eventNameLabel": "Event name",
          "dateLabel": "Date",
          "endDateLabel": "End date (optional)",
          "allDayLabel": "All day",
          "startTimeLabel": "Start time",
          "endTimeLabel": "End time (optional)",
          "addressLabel": "Address (optional)",
          "externalLinkLabel": "Virtual meeting link (optional)",
          "externalLinkInvalid": "Enter a full web address starting with http:// or https://. It will not be saved until it does.",
          "locatedTooltip": "Located on the map",
          "clearLabel": "Clear {{field}}",
          "addEvent": "Add event",
          "expandEvent": "Edit event {{name}}",
          "collapseEvent": "Done editing this event",
          "unnamedEvent": "New event",
          "saveProblem": {
            "missingName": "Event name is required*",
            "missingDate": "Event date is required*",
            "missingStartTime": "Event time is required*",
            "invalidExternalLink": "Virtual meeting link must start with http:// or https://"
          },
          "deleteEvent": "Delete event {{name}}",
          "empty": "No events yet. Select the widget to add events.",
          "noUpcomingEvents": "No upcoming events.",
          "viewAll": "View all events ({{count}})",
          "dialogTitle": "Events",
          "upcomingEvents": "Upcoming events",
          "pastEvents": "Past events",
          "eventToAdd": "Event to add",
          "to": "to",
          "joinOnline": "Join online",
          "joinOnlineFor": "Join {{name}} online",
          "opensInNewTab": "opens in a new tab",
          "showOnMap": "Show {{address}} on the map"
        },
        "saveWidgetFailed": "The widget could not be saved. Please try again.",
        "saveStatus": {
          "saving": "Saving",
          "saved": "Saved",
          "failed": "Save failed"
        },
        "layoutConflict": "This page was changed by someone else. Reloading the latest layout.",
        "layoutNotLive": "This page is no longer the project's live CMS page. Layout changes can't be saved.",
        "deleteFilesFailed": "Some files could not be deleted. Please try again.",
        "renameFilesFailed": "Some file names could not be saved. Please try again.",
        "reorderFilesFailed": "The new order could not be saved. Please try again.",
        "addWidgetFailed": "The widget could not be added. Please try again.",
        "deleteWidgetFailed": "The widget could not be deleted. Please try again.",
        "addSectionFailed": "The section could not be added. Please try again.",
        "deleteSectionFailed": "The section could not be deleted. Please try again.",
        "deleteWidgetDialog": {
          "header": "Delete this widget?",
          "message": "This will permanently delete this widget and its content. This can't be undone."
        }
      },
      "page": {
        "header": "Project Page Setup",
        "tabs": {
          "publicMapPageSetup": "Project Page Setup",
          "embeddableMapSetup": "Embeddable Map Setup"
        },
        "subheadingPartOne": "Your Project Page is the public-facing space where visitors can view and interact with your map. You can customize this page by adding a logo, header, body text, and project files to provide additional context.",
        "subheadingPartTwo": "If you already have an informational website and prefer to embed your map within an existing page, use the Embeddable Map Setup tab below to configure and display your project information accordingly.",
        "publicMapPageSetup": {
          "headerLabel": "Header",
          "subheader": "Upload your logo and header here.",
          "editHeaderLabel": "Edit Header",
          "bodyLabel": "Project Info",
          "bodySubheader": "Add project information here.",
          "editBodyLabel": "Edit Project Info",
          "editProjectFilesLabel": "Edit Files",
          "projectLogoAltText": "Project Logo",
          "editHeaderDialog": {
            "header": "Edit Header",
            "form": {
              "fields": {
                "logo": {
                  "label": "Project Logo",
                  "hint": "SVG, PNG, JPG or GIF"
                },
                "title": {
                  "label": "Page Title"
                },
                "subtitle": {
                  "label": "Subtitle or Tagline"
                }
              }
            }
          },
          "editBodyDialog": {
            "header": "Edit Body"
          },
          "editFilesDialog": {
            "header": "Edit Files",
            "form": {
              "fields": {
                "sectionHeading": {
                  "label": "Section Heading"
                },
                "files": {
                  "label": "Upload File",
                  "hint": "PDF (max. 10MB)"
                }
              }
            },
            "table": {
              "headers": {
                "fileName": "File Name",
                "displayName": "Display Name",
                "uploadDate": "Upload Date",
                "actions": "Actions"
              },
              "values": {
                "deleteFileButtonLabel": "Delete",
                "emptyStateLabel": "No files exist"
              }
            }
          }
        },
        "embeddableMapSetup": {
          "welcomeTextLabel": "Project Info",
          "subheader": "Add project information here. This will show up on your embeddable map under \"Welcome\" in the map navigation.",
          "editWelcomeTextLabel": "Edit Project Info",
          "editWelcomeTextDialog": {
            "header": "Edit Project Info"
          }
        }
      },
      "preview": {
        "header": "Project Page Preview",
        "controls": {
          "previewMessage": {
            "viewing": "You are currently viewing a",
            "for": "for",
            "previewMode": "in Preview Mode."
          },
          "previewOfDropdownLabel": "Preview of",
          "previewPhaseDropdownLabel": "Phase",
          "previewOptions": {
            "projectPage": "Project Page",
            "embeddableMap": "Embeddable Map"
          },
          "colorScheme": {
            "ariaLabel": "Color scheme",
            "light": "Light mode",
            "dark": "Dark mode"
          },
          "viewport": {
            "ariaLabel": "Viewport",
            "desktop": "Desktop",
            "tablet": "Tablet",
            "mobile": "Mobile"
          }
        }
      },
      "settings": {
        "info": {
          "name": "Project Name",
          "url": "Project URL",
          "projectOwner": "Project Owner",
          "billingAccount": "Billing Account",
          "countryLocated": "Country where located",
          "defaultLanguage": "Default language",
          "editButton": "Edit Project Info"
        }
      },
      "country": {
        "US": "United States",
        "CA": "Canada",
        "MX": "Mexico"
      },
      "language": {
        "en": "English",
        "es": "Spanish",
        "fr": "French"
      },
      "projectItemActionsMenu": {
        "actionsLabel": "Actions",
        "actions": {
          "previewProjectPage": "Preview Project Page",
          "shareProject": "Share Project",
          "phaseSettings": "Phase Settings",
          "managePhases": "Manage Phases",
          "commentSettings": "Comment Settings",
          "exportAllComments": "Export All Comments",
          "surveySettings": "Survey Settings",
          "exportResponses": "Export Responses"
        }
      }
    },
    "tenant-selector": {
      "title": "Select Organization"
    },
    "tenants": {
      "table": {
        "ariaLabel": "List of organizations",
        "headers": {
          "name": "Name"
        }
      }
    },
    "mapPreview": {
      "header": "Map Preview",
      "legend": {
        "header": "Legend",
        "emptyStateLabel": "You currently have no layers on your map.",
        "disabledTooltip": "This layer is currently being configured."
      },
      "mapViews": {
        "header": "Map Views",
        "mapViewSelectLabel": "map views",
        "disabledTooltipText": "The dropdown is disabled because only one map view is set up.",
        "languageSelectorButtonAriaLabel": "Select language"
      }
    },
    "mapViews": {
      "header": "Map Views",
      "subheader": "Views allow visitors to switch between different presentations of the map and its related features.",
      "emptyStateLabel": "You currently have no Map Views",
      "buttons": {
        "newMapView": "New Map View",
        "addLayer": "Add Layer",
        "actionsAriaLabel": "Actions for {{name}}",
        "editAriaLabel": "Edit layer",
        "deleteAriaLabel": "Delete layer"
      },
      "actions": {
        "rename": "Rename",
        "delete": "Delete"
      },
      "layersTable": {
        "headers": {
          "name": "Layer Name",
          "missingFeatures": {
            "warning": "No Features Added",
            "tooltip": "This layer has no features yet, so it won't be displayed on the map preview."
          },
          "color": "Color",
          "actions": "Actions"
        },
        "emptyStateLabel": "You currently have no Layers"
      },
      "mapViewForm": {
        "new": {
          "header": "New Map View"
        },
        "rename": {
          "header": "Rename Map View"
        },
        "subheader": "Next you'll upload your layers.",
        "form": {
          "fields": {
            "displayName": {
              "label": "Display Name"
            }
          }
        }
      },
      "dialog": {
        "remove": {
          "header": "Remove Map View",
          "message": "Are you sure you wish to remove this map view from the project?",
          "warning": "Deleting this Map View will also delete any associated comments. Are you sure you wish to delete this Map View?",
          "removeButtonLabelWithWarning": "Remove Map View & Comments"
        }
      },
      "layers": {
        "mapLayerTypeSelection": {
          "header": "Add Layer to View",
          "uploadFile": {
            "title": "Upload a Layer",
            "textContent": "Select files on your computer to create a style a new map layer. Supported file types: GeoJSON"
          },
          "infoLayer": {
            "title": "Create a Layer",
            "textContent": "This option allows you to create your own layer by placing points or drawing lines or polygons on a map. You are also able to attach images to each layer feature, allowing you to add valuable information for your visitors."
          },
          "actions": {
            "continue": "Continue",
            "cancel": "Cancel"
          }
        },
        "removeDialog": {
          "header": "Remove Layer",
          "message": "Are you sure you wish to remove this map layer?",
          "removeSuccess": "Layer has been successfully removed.",
          "removeFailed": "Failed to remove layer."
        },
        "layerForm": {
          "add": {
            "header": "Upload a Layer",
            "subheader": "Here you can name, upload, and style your layer as you would like it to appear on the map. You may upload more than one file to a layer."
          },
          "edit": {
            "header": "Edit Layer",
            "subheader": "Here you can name, upload, and style your layer as you would like it to appear on the map. You may upload more than one file to a layer."
          },
          "infoLayer": {
            "add": {
              "header": "Create a Layer",
              "subheader": "First, select the type of layer you want to configure, and style it. Once the layer is saved, you can begin adding features and include unique attributes such as a title, description, and images."
            },
            "edit": {
              "header": "Edit Info Layer",
              "subheader": "First, select the type of layer you want to configure, and style it. Once the layer is saved, you can begin adding features and include unique attributes such as a title, description, and images."
            },
            "infoLayerOptions": {
              "label": "Feature Type",
              "tooltip": " A layer must consist of only one type of feature type (i.e., point, line, or polygon)",
              "ariaLabel": "Info layer options",
              "options": {
                "point": "Point",
                "line": "Line",
                "polygon": "Polygon",
                "rectangle": "Rectangle",
                "circle": "Circle"
              }
            },
            "mapFeatureForm": {
              "form": {
                "fields": {
                  "title": {
                    "label": "{{ featureType }} Title"
                  },
                  "description": {
                    "label": "{{ featureType }} Description"
                  },
                  "upload": {
                    "label": "Upload File",
                    "hint": "PDF, SVG, PNG, JPG or GIF (max. 3MB)"
                  }
                }
              },
              "removeDialog": {
                "header": "Remove Map Feature",
                "message": "Are you sure you wish to remove this map feature?"
              },
              "notifications": {
                "success": "{{ featureType }} details have been saved.",
                "remove": "{{ featureType }} has been removed."
              }
            },
            "notifications": {
              "success": "Layer has been saved"
            },
            "saveLayerButtonLabel": "Save Layer",
            "addFeatureButtonLabel": "Add {{ featureType }}",
            "addPointBannerText": "Select a location to add your {{ featureType }}. Once selected, you will be prompted to add {{ featureType }} details.",
            "addLineBannerText": "Select multiple locations to add your {{ featureType }}. Once selected, you will be prompted to add {{ featureType }} details."
          },
          "form": {
            "fields": {
              "layerName": {
                "label": "Layer Name"
              },
              "layerDescription": {
                "label": "Layer Description"
              },
              "selectedIcon": {
                "label": "Selected Icon:"
              },
              "files": {
                "label": "Upload File",
                "tooltip": "To display individual feature attributes—such as a title or description—on hover, ensure your GeoJSON properties follow the simplestyle specification. Specifically, include a \"title\" and/or \"description\" property in each feature.",
                "hint": "GeoJSON (max. 10MB), Shapefile (.zip or individual .shp, .dbf, .prj, .cpg files)"
              }
            },
            "sections": {
              "strokeStyle": {
                "label": "Stroke Style",
                "fields": {
                  "strokeColor": {
                    "label": "Stroke Color"
                  },
                  "strokeWidth": {
                    "label": "Stroke Width"
                  }
                }
              },
              "fillStyle": {
                "label": "Fill Style",
                "fields": {
                  "fillColor": {
                    "label": "Fill Color"
                  }
                }
              },
              "advancedOptions": {
                "label": "Advanced Options",
                "note": "Changing settings in this section may cause the layer to not meet accessibility standards.",
                "fields": {
                  "strokeOpacity": {
                    "label": "Stroke Opacity"
                  },
                  "fillOpacity": {
                    "label": "Fill Opacity"
                  }
                }
              }
            }
          }
        }
      }
    },
    "mapStyle": {
      "title": "Map Settings",
      "defaultMapStyle": "Default Map Style",
      "visitorCanChangeStyle": "Visitor Can Change Style",
      "enableThreeDimensionalBuildings": "Enable 3D Buildings",
      "yes": "Yes",
      "no": "No",
      "changeSettingsButton": "Change Settings",
      "editMapStyleSettingsDialog": {
        "header": "Map Style Settings",
        "selectMapStyle": "Select the default map style",
        "visitorCanSwitchMapStyle": "Allow visitor to switch map styles?",
        "threeDimensionalBuildingsEnabled": "Display buildings in 3 dimensions?"
      }
    }
  },
  "product": {
    "sideNavMenu": {
      "productAdmin": {
        "organizations": "Organizations",
        "skus": "SKUs"
      }
    },
    "marketplace": {
      "types": {
        "Unknown": "Unknown",
        "AzureMarketplace": "Azure Marketplace"
      }
    },
    "subscription": {
      "types": {
        "Unknown": "Unknown",
        "AzureMarketplace": "Azure Marketplace",
        "KHTS": "KHTS"
      }
    },
    "skus": {
      "title": "SKUs",
      "skuList": {
        "emptyStateLabel": "No listings available",
        "addSkuButtonText": "Add SKU",
        "addListingButtonText": "Add Listing",
        "buttons": {
          "editAriaLabel": "Edit listing",
          "deleteAriaLabel": "Delete listing",
          "actionsAriaLabel": "Actions for {{name}}"
        },
        "actions": {
          "edit": "Edit",
          "delete": "Delete"
        },
        "listingTable": {
          "headers": {
            "listingName": "Listing Name",
            "marketplaceType": "Marketplace Type",
            "listingId": "listing ID",
            "actions": "Actions"
          }
        },
        "dialog": {
          "remove": {
            "header": "Remove {{ sku }}",
            "message": "Are you sure you wish to remove {{ sku }}?",
            "warning": "Deleting this SKU will also delete any associated listing. Are you sure you wish to delete this SKU?"
          },
          "removeListing": {
            "header": "Remove {{ skuListing }}",
            "message": "Are you sure you wish to remove {{ skuListing }}?"
          }
        },
        "notifications": {
          "skuAdded": "SKU has been added.",
          "skuEdited": "SKU has been updated.",
          "skuRemoved": "SKU has been removed.",
          "skuListingAdded": "SKU listing has been added.",
          "skuListingEdited": "SKU listing has been updated.",
          "skuListingDeleted": "SKU listing has been removed."
        }
      },
      "listingItem": {
        "form": {
          "header": "Add SKU marketplace listing",
          "editHeader": "Edit SKU marketplace listing",
          "marketplaceType": {
            "label": "Marketplace Type",
            "tooltip": "NOTE: This is not editable once set"
          },
          "listingName": "Listing Name",
          "listingId": {
            "label": "Listing ID",
            "tooltip": "NOTE: This is not editable once set"
          }
        }
      },
      "skuForm": {
        "add": {
          "header": "Add SKU"
        },
        "edit": {
          "header": "Edit SKU"
        },
        "form": {
          "fields": {
            "name": {
              "label": "Name"
            },
            "numberOfProjects": {
              "label": "Number of Projects",
              "hint": "Leave empty for unlimited projects"
            },
            "inquiryState": {
              "label": "Inquiry State - Do Not Activate Azure Marketplace Subscription"
            },
            "allowCustomNumberOfProjects": {
              "label": "Allow custom number of projects"
            }
          }
        }
      }
    },
    "organizations": {
      "title": "Organizations",
      "addOrganizationButtonText": "Add Organization",
      "addOrganizationOwner": "Add Organization Owner",
      "organizationSettings": {
        "header": {
          "title": "Organization Settings",
          "changeSettingsButton": "Change Settings"
        },
        "content": {
          "name": "Name",
          "id": "Id",
          "billingAccount": "Billing Account",
          "autoAddUser": "Auto Add User",
          "defaultOrgRoles": "Default Org Roles",
          "defaultProjectRoles": "Default Project Roles",
          "enabled": "Enabled",
          "disabled": "Disabled"
        },
        "dialog": {
          "nameLabel": "Organization Name",
          "enableBillingAccountLabel": "Enable Billing Account Feature Flag",
          "enableAutoAddUserLabel": "Auto Add User",
          "autoAddUserEntraIdsTooltip": "Automatically add users to the organization that have the following Entra Tenant Ids.  Press Enter to add an additional guid to the list.",
          "autoAddUserEntraIdsPlaceholder": "e.g. 7e220d30-0b59-47e5-8a81-a4a9d9afbdc4",
          "autoAddUserConfigurationLabel": "Auto Add User Configuration (Entra Tenant Ids)",
          "enableCommentVotingLabel": "Enable Comment Voting",
          "defaultOrgRolesLabel": "Default Organization Roles",
          "defaultProjectRolesLabel": "Default Project Roles",
          "yes": "Yes",
          "no": "No"
        },
        "notifications": {
          "updateOrganizationSettingsSuccess": "Organization settings have been updated",
          "updateOrganizationSettingsFailed": "Error updating organization settings"
        }
      },
      "add": {
        "header": "Add Organization",
        "form": {
          "fields": {
            "name": {
              "label": "Organization Name"
            },
            "owners": {
              "label": "Organization Owner(s)",
              "removeOwnerButtonAriaLabel": "Remove owner {{ email }}"
            },
            "contractId": {
              "label": "Contract ID"
            },
            "licenseTier": {
              "label": "License Tier"
            },
            "numberOfProjects": {
              "label": "Number of Projects"
            }
          },
          "sections": {
            "subscriptionPeriod": {
              "label": "Subscription Period",
              "fields": {
                "subscriptionStartDate": {
                  "label": "Subscription Start Date"
                },
                "subscriptionEndDate": {
                  "label": "Subscription End Date"
                }
              }
            },
            "pointOfContact": {
              "label": "Kimley-Horn Point of Contact",
              "fields": {
                "name": {
                  "label": "Name"
                },
                "emailAddress": {
                  "label": "Email Address"
                }
              }
            }
          }
        }
      },
      "table": {
        "ariaLabel": "List of organizations",
        "headers": {
          "name": "Name",
          "purchaseChannel": "Purchase Channel",
          "subscriptionStatus": "Subscription Status",
          "subscriptionStartDate": "Subscription Start Date",
          "subscriptionEndDate": "Subscription End Date",
          "licenseTier": "License Tier",
          "numberOfProjects": "Projects",
          "projectsRemaining": "Remaining",
          "actions": "Actions"
        },
        "values": {
          "markedForDeletion": "Marked for Deletion",
          "emptyStateLabel": "No organizations available",
          "unlimited": "Unlimited"
        },
        "actions": {
          "manageSubscription": "Manage Subscription",
          "manageOrganization": "Manage Organization"
        }
      },
      "subscriptions": {
        "addSubscription": "Add Subscription",
        "notifications": {
          "subscriptionAdded": "Subscription added successfully",
          "subscriptionAddError": "Error adding subscription",
          "subscriptionRenewed": "Subscription renewed successfully",
          "subscriptionRenewError": "Error renewing subscription",
          "subscriptionCancelled": "Subscription cancelled successfully",
          "subscriptionCancelError": "Error cancelling subscription",
          "subscriptionSuspended": "Subscription suspended successfully",
          "subscriptionSuspendError": "Error suspending subscription",
          "subscriptionUnsubscribed": "Subscription unsuspended successfully",
          "subscriptionUnsubscribeError": "Error unsuspending subscription"
        },
        "table": {
          "ariaLabel": "List of subscriptions",
          "headers": {
            "contractId": "Contract ID",
            "subscriptionStatus": "Subscription Status",
            "subscriptionStartDate": "Subscription Start Date",
            "subscriptionEndDate": "Subscription End Date",
            "licenseTier": "License Tier",
            "numberOfProjects": "Number of Projects",
            "actions": "Actions",
            "cancelSubscription": "Cancel {{ subscriptionName }}",
            "suspendSubscription": "Suspend Subscription",
            "unsuspendSubscription": "Unsuspend Subscription"
          },
          "values": {
            "addSubscription": "Add Subscription",
            "editSubscription": "Edit Subscription",
            "deleteSubscription": "Delete Subscription",
            "filters": "Filters"
          },
          "actions": {
            "renewSubscription": "Renew Subscription",
            "cancelSubscription": "Cancel Subscription",
            "suspendSubscription": "Suspend Subscription",
            "unsuspendSubscription": "Unsuspend Subscription"
          }
        },
        "cancelSubscription": {
          "message": "Are you sure you wish to cancel this subscription?"
        },
        "status": {
          "subscribed": "Subscribed",
          "unsubscribed": "Unsubscribed",
          "suspended": "Suspended"
        },
        "add": {
          "form": {
            "fields": {
              "contractId": {
                "label": "Contract ID"
              },
              "licenseTier": {
                "label": "License Tier"
              },
              "numberOfProjects": {
                "label": "Number of Projects"
              }
            },
            "sections": {
              "subscriptionPeriod": {
                "label": "Subscription Period",
                "fields": {
                  "subscriptionStartDate": {
                    "label": "Subscription Start Date"
                  },
                  "subscriptionEndDate": {
                    "label": "Subscription End Date"
                  }
                }
              }
            }
          }
        },
        "cancel": {
          "form": {
            "sections": {
              "subscriptionPeriod": {
                "fields": {
                  "cancellationDate": {
                    "label": "Cancellation effective"
                  }
                }
              }
            }
          }
        },
        "suspendSubscription": {
          "header": "Suspend Subscription",
          "message": "Are you sure you wish to suspend this subscription?",
          "suspendButtonLabel": "Suspend Subscription"
        },
        "unsuspendSubscription": {
          "header": "Unsuspend Subscription",
          "message": "Are you sure you wish to unsuspend this subscription? This will set the subscription's status back to active.",
          "unsuspendButtonLabel": "Unsuspend Subscription"
        }
      }
    }
  },
  "acceptInvite": {
    "stepOneLogin": {
      "title": "Welcome to PublicCoordinate",
      "subtitle": "Please login using your email below to continue."
    },
    "stepTwoVerifyEmail": {
      "title": "Welcome to PublicCoordinate",
      "subtitle": "Please enter the six digit code sent to the same email address as your invite email.",
      "verificationCode": {
        "label": "Verification Code",
        "errors": {
          "pattern": "{{field}} can only contain numbers.",
          "invalidOrExpired": "The code you entered is invalid, expired, or has already been used. Please try again."
        }
      },
      "submitButtonLabel": "Accept Invite"
    },
    "stepError": {
      "title": "Welcome to PublicCoordinate",
      "subtitle": "An error occurred while processing your request. Ask the person who sent you the invite to resend it."
    }
  },
  "auth": {
    "testimonial": {
      "title": "Engagement that Exceeds Expectations",
      "subtitle": "PublicCoordinate is an interactive map-based solution to inform and engage stakeholders throughout your project's lifecycle"
    },
    "loggedOut": {
      "title": "You've been logged out.",
      "subtitle": "You have successfully signed out on this device. Thanks again for using PublicCoordinate. You may return to the Sign In page to return to work on your projects.",
      "redirectLabel": "Return to Sign In"
    },
    "login": {
      "header": {
        "title": "Welcome back",
        "subtitle": "Welcome back! Please enter your email."
      },
      "form": {
        "formLabel": "Login form",
        "fields": {
          "emailAddress": {
            "label": "Email",
            "placeholder": "Email"
          },
          "rememberMe": {
            "label": "Remember me"
          }
        },
        "termsOfUse": {
          "beforeLink": "By clicking \"Sign In,\" I hereby agree to the ",
          "linkText": "Terms of Use",
          "opensInNewTab": "(opens in a new tab)",
          "afterLink": " for use of PublicCoordinate. I understand that PublicCoordinate is the sole property of KHTS, Inc. and unauthorized use and copying is strictly prohibited."
        },
        "buttonText": "Sign In",
        "identityProviderSignInButtons": {
          "entraId": {
            "buttonLabel": "Sign in with a Microsoft Account",
            "buttonText": "Microsoft Account"
          },
          "entraExternalId": {
            "buttonLabel": "Sign in with a PublicCoordinate Account",
            "buttonText": "PublicCoordinate Account"
          }
        },
        "signUpLink": {
          "text": "Don't have an account?",
          "linkText": "Sign up for a PublicCoordinate Account"
        }
      }
    },
    "loginFailed": {
      "title": "Login Failed",
      "subtitle": "Sorry, something went wrong trying to log you in.",
      "redirectLabel": "Home"
    },
    "logout": {
      "title": "Logging you out.",
      "subtitle": "Thanks for using PublicCoordinate. Please wait while we log you out on this device."
    }
  },
  "azureMarketplace": {
    "transactable": {
      "title": "You're almost done. Activate your subscription!",
      "subtitle": "Activate your subscription to start putting your projects on the map and your community in the conversation.",
      "body": "Please review your subscription details below.",
      "loading": "Loading...",
      "logIn": {
        "title": "Activate your subscription!",
        "subtitle": "Before we can activate your subscription, you need to sign in to the same account as your Azure subscription.",
        "signInButtonLabel": "Sign in with Microsoft Account"
      },
      "inquiryStep": {
        "title": "Thank you for your interest in PublicCoordinate!",
        "subtitle": "Please confirm your contact details below. If you are not the best point of contact for your organization, feel free to update the information so our team can reach out to the appropriate person.",
        "form": {
          "fields": {
            "name": {
              "label": "Name"
            },
            "organizationName": {
              "label": "Organization"
            },
            "emailAddress": {
              "label": "Email"
            },
            "phoneNumber": {
              "label": "Phone"
            },
            "description": {
              "label": "Description"
            },
            "preferredContactMethod": {
              "label": "Preferred method of communication",
              "options": {
                "email": "Email",
                "phone": "Phone"
              }
            }
          },
          "submitButtonLabel": "Submit"
        },
        "confirmationMessage": "Thank you for your interest in PublicCoordinate! Our team will be in touch with you shortly."
      },
      "activateSubsctionStep": {
        "subscriptionDetailsFields": {
          "subscriptionName": "Subscription Name:",
          "planName": "Plan Name:",
          "quantity": "Quantity:"
        },
        "form": {
          "fields": {
            "userDisplayName": {
              "label": "User Display Name"
            },
            "userEmail": {
              "label": "User Email"
            },
            "tenantName": {
              "label": "Organization Name"
            }
          },
          "activateButtonLabel": "Activate Subscription"
        }
      },
      "loadingForActivateSubscriptionForm": {
        "title": "Activating your subscription!",
        "subtitle": "Please wait while we activate your subscription with the Azure Marketplace.",
        "body": "This may take a few minutes. We will redirect you once it's complete.",
        "loadingProgressBar": "Activating subscription..."
      }
    }
  },
  "pageTitles": {
    "acceptInvite": "Accept Invitation",
    "admin": {
      "organization": {
        "settings": "Organization Settings | {{organizationName}}",
        "users": "User Management | {{organizationName}}"
      },
      "organizations": "Select Organization",
      "projects": {
        "index": "Project List | {{organizationName}}",
        "project": {
          "comments": "Comments | {{phaseName}} | {{projectName}} | {{organizationName}}",
          "overview": "Project Overview | {{phaseName}} | {{projectName}} | {{organizationName}}",
          "settings": {
            "collaborators": "Collaborators | Project Settings | {{projectName}} | {{organizationName}}",
            "comments": "Comment Categories | Project Settings | {{phaseName}} | {{projectName}} | {{organizationName}}",
            "info": "Project Info | Project Settings | {{projectName}} | {{organizationName}}",
            "map": "Maps & Layers | Project Settings | {{phaseName}} | {{projectName}} | {{organizationName}}",
            "page": "Project Page | Project Settings | {{projectName}} | {{organizationName}}",
            "projectPageCmsBuilder": "Project Page Cms Builder | Project Settings | {{projectName}} | {{organizationName}}",
            "phases": "Phases | Project Settings | {{projectName}} | {{organizationName}}",
            "survey": "Survey | Project Settings | {{phaseName}} | {{projectName}} | {{organizationName}}",
            "translations": "Translations | Project Settings | {{phaseName}} | {{projectName}} | {{organizationName}}"
          },
          "surveys": "Survey Responses | {{phaseName}} | {{projectName}} | {{organizationName}}"
        }
      }
    },
    "auth": {
      "authenticating": "Authenticating...",
      "loggedOut": "Logged Out",
      "login": "Sign In",
      "loginFailed": "Login Failed",
      "logout": "Logging Out"
    },
    "azureMarketplace": {
      "transactable": "Activate Subscription"
    },
    "pageNotFound": "Page Not Found",
    "productAdmin": {
      "organizations": "Organizations | Product Admin",
      "skus": "SKUs | Product Admin"
    },
    "project": {
      "embed": "{{publicProjectName}} | Embedded Map",
      "index": "{{publicProjectName}}"
    }
  },
  "pageNotFound": {
    "title": "Page Not Found",
    "subtitleWithoutTenant": "Sorry! The page you’re looking for was not found. Try going back to the previous page and navigate again.",
    "subtitleWithTenant": "Sorry! The page you’re looking for was not found. Try going back to the previous page and navigate again or you may return to the Project List.",
    "returnToProjectList": "Return to Project List",
    "returnToHome": "Return to Home"
  },
  "header": {
    "logo": {
      "ariaLabel": "PublicCoordinate home page"
    },
    "profileMenu": {
      "ariaLabel": "Profile context menu",
      "editProfile": "Edit profile settings",
      "logout": {
        "label": "Log out",
        "ariaLabel": "log out"
      },
      "switchTenants": {
        "label": "Change Organization",
        "ariaLabel": "Navigate to the Select Organization Page"
      },
      "avatar": {
        "ariaLabel": "User Settings"
      },
      "editProfileDialog": {
        "header": "My Profile",
        "fileUploaderHint": "PNG, JPG or GIF",
        "avatar": {
          "ariaLabel": "Delete the profile avatar image"
        },
        "form": {
          "fields": {
            "name": {
              "label": "Name"
            },
            "email": {
              "label": "Email"
            }
          }
        }
      }
    },
    "helpMenu": {
      "ariaLabel": "Help center context menu",
      "userGuide": {
        "label": "Admin User Guide",
        "ariaLabel": "Admin User Guide"
      },
      "support": {
        "label": "Report an Issue",
        "ariaLabel": "Report an Issue"
      }
    },
    "controls": {
      "accountSettings": {
        "ariaLabel": "Organization Settings"
      },
      "helpCenter": {
        "ariaLabel": "Help Center"
      }
    }
  },
  "projectPage": {
    "projectFilesLabel": "Project Files",
    "header": {
      "logoAltText": "Project logo"
    }
  },
  "translationsDropdown": {
    "compactAriaLabel": "Select language"
  },
  "map": {
    "widgets": {
      "navigation": {
        "ariaLabel": "Map navigation"
      },
      "locationSearch": {
        "placeholder": "Enter an address",
        "clearAriaLabel": "Clear search",
        "noResults": "No locations found"
      },
      "layerDetails": {
        "header": "Layer Details",
        "featureDetailsHeader": "Feature Details"
      },
      "filter": {
        "buttonAriaLabel": "Filter comments",
        "header": "Filter Comments",
        "disabledCommentCategoryTooltipText": "This comment category has no comments."
      },
      "survey": {
        "buttonLabel": "Take Survey",
        "header": "Take a survey"
      },
      "comment": {
        "addCommentButtonLabel": "Add Comment",
        "add": {
          "typeSelection": {
            "header": "Choose comment type",
            "selectButtonLabel": "Select"
          },
          "header": "What's on your mind?",
          "plotModeBannerText": "Tap the map to add your {{ categoryType }}. When you're finished, select \"done\" and a box will appear to leave your comment.",
          "notifications": {
            "commentSubmitted": "Your comment has been submitted. Thank you for your feedback!"
          },
          "form": {
            "codeOfConduct": "By submitting this comment you agree to the <a href='{{ link }}' target='_blank'><u>Code of Conduct</u></a>.",
            "fields": {
              "comment": {
                "label": "Your Comment"
              },
              "emailAddress": {
                "label": "Email Address",
                "hint": "Your email will only be visible to the project team."
              },
              "imageUpload": {
                "label": "Upload Image",
                "hint": "SVG, PNG, JPG or GIF (max. 3MB)"
              }
            }
          }
        },
        "view": {
          "header": "What's on your mind?",
          "vote": {
            "upvoteAriaLabel": "Upvote",
            "downvoteAriaLabel": "Downvote",
            "removeVoteAriaLabel": "Remove vote"
          },
          "notifications": {
            "replySubmitted": "Your reply has been submitted. Thank you for your feedback!"
          },
          "form": {
            "fields": {
              "reply": {
                "label": "Reply"
              },
              "emailAddress": {
                "label": "Email Address",
                "hint": "Your email will only be visible to the project team."
              },
              "imageUpload": {
                "label": "Upload Image",
                "hint": "SVG, PNG, JPG or GIF (max. 3MB)"
              }
            },
            "actions": {
              "replyButtonLabel": "Reply",
              "clearButtonLabel": "Clear"
            }
          }
        }
      }
    },
    "styleOption": {
      "Classic": "Classic",
      "Monochrome": "Monochrome",
      "Satellite": "Satellite",
      "Standard": "Standard"
    },
    "mapStyleDrawer": {
      "header": "Change map style",
      "cancelButton": "Cancel",
      "applyButton": "Apply"
    },
    "reportIssueDrawer": {
      "header": "Report an Issue",
      "successSnackbar": "Your feedback has been submitted. Thank you for your feedback!",
      "errorSnackbar": "There was an error submitting your feedback. Please try again later.",
      "feedbackTypes": {
        "bug": "Report a bug",
        "map": "I'm having trouble accessing the map",
        "comment": "I'm having trouble commenting",
        "survey": "I'm having trouble with the survey",
        "featureRequest": "Suggest a feature",
        "other": "Other"
      },
      "form": {
        "displayName": "Name",
        "emailAddress": "Email",
        "feedbackType": "Issue type",
        "message": "Give a brief description of the issue"
      }
    },
    "projectInfoDrawer": {
      "header": "About the project",
      "closeButton": "Close"
    },
    "helpDrawer": {
      "header": "How to use the map",
      "closeButton": "Close",
      "instructions": {
        "howToNavigateMap": {
          "header": "How to Navigate the PublicCoordinate Map",
          "mapViews": {
            "title": "Map Views",
            "content": "Map views are often used to display multiple concept plans, alternatives, jurisdictions, and more for community projects. To use Map Views, select the “Map Views” drop down menu in the top left corner of the map. From there, you can navigate through the project's different Map Views and leave comments that are tied to specific Map Views."
          },
          "mapStyles": {
            "title": "Map Styles",
            "content": "Use the “Map Style” button in the navigation bar to toggle between map styles, like satellite and greyscale."
          },
          "legend": {
            "title": "Legend",
            "content": "The map legend displays important project information for you to view. You can toggle the legend on/off by selecting the “Legend” icon in the navigation bar."
          }
        },
        "translate": {
          "title": "Translate",
          "content": "To translate the project page into another language, select the “Language” icon. You will be prompted to select your desired language."
        },
        "reportIssue": {
          "title": "Report an Issue",
          "content": "If you encounter any issues or bugs while using the map, you may report an issue using the “Report Issue” button in the navigation bar.  You will be prompted to identify the type of issue you are having. In the case that you are experiencing a software bug, PublicCoordinate’s support team will work quickly to address the issue."
        },
        "howToProvideFeedback": {
          "header": "How to Provide Your Feedback",
          "canAddComment": {
            "title": "Add a Comment",
            "content": {
              "default": "We want to hear from you! To submit a comment, select the blue \"Add a Comment\" button in the bottom right corner of the map. You'll be prompted to select a comment category. Select the category that aligns the best with your feedback.",
              "hasPointCategory": "Point comments allow you to tie your feedback to a specific location on the map. To add a point comment, you will be prompted on-screen to select the location you would like to drop your comment.",
              "hasLineCategory": "Line comments allow you to draw a line that is associated with your feedback. To add a line comment, you will be prompted on-screen to select the location you would like to start your line, and you may continue adding points to your line until you are ready to add your comment."
            }
          },
          "canTakeSurvey": {
            "title": "Take a Survey",
            "content": "Your feedback is valuable. To submit a survey response, select the blue and white “Take Survey” button at the bottom right of the screen. You will be prompted to answer several questions and to submit your responses."
          },
          "canReplyToComment": {
            "title": "Reply to a Comment",
            "content": "You can reply to comments on the map to provide additional project feedback. First, select the comment. The comment thread will appear to the right of your screen, and you will be prompted to provide a reply. Once you have typed your response, select “Reply” at the bottom of the reply window."
          },
          "canVoteOnComment": {
            "title": "Vote on a Comment",
            "content": "You can upvote or downvote comments on the map to provide additional project feedback. First, select the comment. The comment thread will appear to the right of your screen, and you may upvote or downvote by selecting the “thumbs up” (upvote) and “thumbs down” (downvote) icons below the comment. The selected voting option will appear filled in, and you may deselect your vote by re-clicking the upvote or downvote icon."
          },
          "canUploadImageToComment": {
            "title": "Upload an Image to a Comment",
            "content": "You may upload an image to your comment to provide additional context. When commenting on the map, you may upload an image through the image upload option below the comment text box. You can upload an SVG, PNG, JPG, or GIF image.  Once uploaded, you may save your comment."
          },
          "canFilterComment": {
            "title": "Filter Comments",
            "content": "You can filter through comment categories by selecting the floating “filter” icon in the top right of your screen, below the map navigation. Once selected, you can toggle between different comment types to tailor the comments that appear visible on the map."
          }
        }
      }
    },
    "languageSelectionDrawer": {
      "header": "Select language",
      "selectField": {
        "label": "Display Language"
      }
    },
    "navigation": {
      "mapNavbar": {
        "projectInfo": "Project Info",
        "mapStyle": "Map Style",
        "legend": "Legend",
        "help": "Help",
        "reportIssue": "Report Issue",
        "language": "Language"
      }
    },
    "controls": {
      "openInFull": "Open in full screen",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "resetNorth": "Reset north",
      "home": "Home"
    },
    "publicSurveyDrawer": {
      "formSubmissionError": "There was an error submitting the form. Please try again later.",
      "formSubmissionConfirmation": "Thank you for your submission!",
      "retakeFormButtonLabel": "Submit another response"
    }
  },
  "loaders": {
    "loading": "Loading...",
    "loadingComments": "Loading Comments...",
    "loadingMapViews": "Loading Map Views...",
    "loadingSkus": "Loading Skus",
    "loadingMetricsItem": "Loading Metrics Item...",
    "loadingMetricsCommentCategories": "Loading Metrics Comment Categories..."
  },
  "carousel": {
    "roleDescription": "carousel",
    "slideRoleDescription": "slide"
  },
  "fullscreenOverlay": {
    "fullscreenAriaLabel": "Open in full screen",
    "openImageFullscreen": "{{alternateText}}. Open in full screen",
    "dialogLabel": "Image viewer",
    "carouselLabel": "Image carousel",
    "slideLabel": "Image {{index}} of {{count}}",
    "imageCounter": "{{index}} of {{count}}",
    "nextButtonAriaLabel": "Next image",
    "previousButtonAriaLabel": "Previous image"
  },
  "richTextEditor": {
    "align_center": "Center Align",
    "align_justify": "Justify",
    "align_left": "Left Align",
    "align_right": "Right Align",
    "altText": "Alt Text",
    "bold": "Bold",
    "bullet_list": "Bullet List",
    "code": "Code",
    "embedImage": "Embed Image",
    "format_clear": "Clear Formatting",
    "h1": "Header 1",
    "h2": "Header 2",
    "h3": "Header 3",
    "h4": "Header 4",
    "h5": "Header 5",
    "h6": "Header 6",
    "heading": "Heading",
    "insert": "Insert",
    "insertImage": "Insert Image",
    "insertLink": "Insert Link",
    "italic": "Italic",
    "openInNewTab": "Open in new tab",
    "ordered_list": "Ordered List",
    "removeLink": "Remove Link",
    "saveChangesErrorSnackbar": "There was an error saving your changes. Please try again later.",
    "strike": "Strike",
    "text_color": "Text Color",
    "text": "Text",
    "title": "Title",
    "underline": "Underline",
    "uploadHint": "SVG, PNG, JPG, JPEG, or GIF (max 800x400px)",
    "uploadImage": "Upload Image",
    "uploadImageErrorSnackbar": "There was an error submitting your image. Please try again later.",
    "url": "URL"
  },
  "linkEditor": {
    "url": "URL",
    "text": "Text",
    "addHyperlinkButtonLabel": "Add"
  },
  "role": {
    "label": {
      "None": "None",
      "OrganizationOwner": "Organization Owner",
      "OrganizationViewer": "Organization Viewer",
      "OrganizationProjectCreator": "Organization Project Creator",
      "ProjectAdministrator": "Project Administrator",
      "ProjectContributor": "Project Contributor",
      "ProjectViewer": "Project Viewer"
    },
    "description": {
      "OrganizationOwner": "Can view, add, edit, and delete all organization content, and add users to the organization.",
      "OrganizationViewer": "Can view all organization content but cannot make organization changes or add users.",
      "OrganizationProjectCreator": "Can create new projects.",
      "ProjectAdministrator": "Can view, add, edit, and delete project content, and add users to projects they manage.",
      "ProjectContributor": "Can view, add, edit, and delete project content, but cannot add collaborators.",
      "ProjectViewer": "Can view project content but cannot make changes."
    }
  }
}
